/*
IMPORTANT
This file is auto-generated.
Do not make manual changes.
Manual changes will be overwritten when the file is next generated.

API:          FADX Platform API
Version:      2
Description:  FADX Platform API provides app calls for mobile and panel apps.
Generated at: 12/01/2026 10:52 (GMT Standard Time)
*/

import axios, { AxiosError, AxiosResponse } from 'axios';
import { ApiError, ApiHelper, IbssRequestConfig, ODataSelect } from '@iconics/core';

export interface IContext
{
    baseUrl: string;
}

export interface IFadxPlatformApiClientV2
{
    v2: IFadxPlatformApiClientV2_V2;


}

export class FadxPlatformApiClientV2 implements IFadxPlatformApiClientV2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.v2 = new FadxPlatformApiClientV2_V2(context);
    }

    public v2: FadxPlatformApiClientV2_V2;


}

export interface IFadxPlatformApiClientV2_V2
{
    core: IFadxPlatformApiClientV2_V2_Core;
    security: IFadxPlatformApiClientV2_V2_Security;
    byNodeid: IFadxPlatformApiClientV2_V2_ByNodeid;
    scim: IFadxPlatformApiClientV2_V2_Scim;


}

export class FadxPlatformApiClientV2_V2 implements IFadxPlatformApiClientV2_V2
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.core = new FadxPlatformApiClientV2_V2_Core(context);
        this.security = new FadxPlatformApiClientV2_V2_Security(context);
        this.byNodeid = new FadxPlatformApiClientV2_V2_ByNodeid(context);
        this.scim = new FadxPlatformApiClientV2_V2_Scim(context);
    }

    public core: FadxPlatformApiClientV2_V2_Core;
    public security: FadxPlatformApiClientV2_V2_Security;
    public byNodeid: FadxPlatformApiClientV2_V2_ByNodeid;
    public scim: FadxPlatformApiClientV2_V2_Scim;


}

export interface IFadxPlatformApiClientV2_V2_Core
{
    byTenancy: IFadxPlatformApiClientV2_V2_Core_ByTenancy;
    tenancies: IFadxPlatformApiClientV2_V2_Core_Tenancies;


}

export class FadxPlatformApiClientV2_V2_Core implements IFadxPlatformApiClientV2_V2_Core
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTenancy = new FadxPlatformApiClientV2_V2_Core_ByTenancy(context);
        this.tenancies = new FadxPlatformApiClientV2_V2_Core_Tenancies(context);
    }

    public byTenancy: FadxPlatformApiClientV2_V2_Core_ByTenancy;
    public tenancies: FadxPlatformApiClientV2_V2_Core_Tenancies;


}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy
{
    attributes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes;
    dataHubCredentials: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials;
    dataHubPublisher: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher;
    byNodeid: IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid;
    entities: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities;
    nodes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes;
    notificationRules: IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules;
    ontologies: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies;
    packages: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages;
    relationships: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships;
    users: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users;
    solutions: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions;
    virtualTreeViews: IFadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews;


}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy implements IFadxPlatformApiClientV2_V2_Core_ByTenancy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.attributes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes(context);
        this.dataHubCredentials = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials(context);
        this.dataHubPublisher = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher(context);
        this.byNodeid = new FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid(context);
        this.entities = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities(context);
        this.nodes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes(context);
        this.notificationRules = new FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules(context);
        this.ontologies = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies(context);
        this.packages = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages(context);
        this.relationships = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships(context);
        this.users = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Users(context);
        this.solutions = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions(context);
        this.virtualTreeViews = new FadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews(context);
    }

    public attributes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes;
    public dataHubCredentials: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials;
    public dataHubPublisher: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher;
    public byNodeid: FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid;
    public entities: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities;
    public nodes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes;
    public notificationRules: FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules;
    public ontologies: FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies;
    public packages: FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages;
    public relationships: FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships;
    public users: FadxPlatformApiClientV2_V2_Core_ByTenancy_Users;
    public solutions: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions;
    public virtualTreeViews: FadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews;


}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostEventField, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/attributes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostEventField, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/attributes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById
{
    entities: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById_Entities;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: string, body: IPutEventField, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.entities = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById_Entities(context);
    }

    public entities: FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById_Entities;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/attributes/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/attributes/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: string, body: IPutEventField, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/attributes/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById_Entities
{

    get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById_Entities implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Attributes_ById_Entities
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/attributes/${options.id}/entities?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostDataHubCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-credentials?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostDataHubCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-credentials?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials_ById
{

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: number, body: IPatchDataHubCredential, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: number, body: IPutDataHubCredential, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubCredentials_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-credentials/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-credentials/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: number, body: IPatchDataHubCredential, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-credentials/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: number, body: IPutDataHubCredential, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-credentials/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostDataHubPublisher, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostDataHubPublisher, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById
{
    entities: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: number, body: IPatchDataHubPublisher, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: number, body: IPutDataHubPublisher, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.entities = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities(context);
    }

    public entities: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: number, body: IPatchDataHubPublisher, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: number, body: IPutDataHubPublisher, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities
{
    byEntityId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byEntityId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId(context);
    }

    public byEntityId: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId
{
    attributes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId_Attributes;

    delete<TResponse>(options: { tenancy: string, id: number, entityId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: number, entityId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPatchEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPostEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPutEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.attributes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId_Attributes(context);
    }

    public attributes: FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId_Attributes;


    public async delete<TResponse>(options: { tenancy: string, id: number, entityId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: number, entityId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPatchEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPostEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPutEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId_Attributes
{

    delete<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId_Attributes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_DataHubPublisher_ById_Entities_ByEntityId_Attributes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}/attributes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: number, entityId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/data-hub-publisher/${options.id}/entities/${options.entityId}/attributes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid
{
    dataPoints: IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints;


}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.dataPoints = new FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints(context);
    }

    public dataPoints: FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints;


}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, tenancy: string, body: IDataPointPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/${options.nodeId}/data-points?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, tenancy: string, body: IDataPointPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/${options.nodeId}/data-points?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById
{
    data: IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById_Data;

    delete<TResponse>(options: { nodeId: number, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, id: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IDataPointPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.data = new FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById_Data(context);
    }

    public data: FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById_Data;


    public async delete<TResponse>(options: { nodeId: number, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/${options.nodeId}/data-points/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, id: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/${options.nodeId}/data-points/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IDataPointPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/${options.nodeId}/data-points/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById_Data
{

    post<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IDataPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById_Data implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_ByNodeid_DataPoints_ById_Data
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IDataPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/${options.nodeId}/data-points/${options.id}/data?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security
{
    byTenancy: IFadxPlatformApiClientV2_V2_Security_ByTenancy;
    users: IFadxPlatformApiClientV2_V2_Security_Users;


}

export class FadxPlatformApiClientV2_V2_Security implements IFadxPlatformApiClientV2_V2_Security
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTenancy = new FadxPlatformApiClientV2_V2_Security_ByTenancy(context);
        this.users = new FadxPlatformApiClientV2_V2_Security_Users(context);
    }

    public byTenancy: FadxPlatformApiClientV2_V2_Security_ByTenancy;
    public users: FadxPlatformApiClientV2_V2_Security_Users;


}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy
{
    delegates: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates;
    identityProviders: IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders;
    roles: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles;
    users: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users;


}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy implements IFadxPlatformApiClientV2_V2_Security_ByTenancy
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.delegates = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates(context);
        this.identityProviders = new FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders(context);
        this.roles = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles(context);
        this.users = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users(context);
    }

    public delegates: FadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates;
    public identityProviders: FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders;
    public roles: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles;
    public users: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users;


}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates
{
    byId: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates_ById;

    delete<TResponse>(options: { tenancy: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IDelegateRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates_ById;


    public async delete<TResponse>(options: { tenancy: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/delegates?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/delegates?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IDelegateRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/delegates?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates_ById
{

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates_ById implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Delegates_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/delegates/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/delegates/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IEventTypePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IEventTypePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById
{
    publishTo: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo;
    attributes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, body: IEventTypePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: string, body: IEventTypePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.publishTo = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo(context);
        this.attributes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes(context);
    }

    public publishTo: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo;
    public attributes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, body: IEventTypePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: string, body: IEventTypePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo
{
    byPublishToId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: number, body: IPostEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byPublishToId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId(context);
    }

    public byPublishToId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: number, body: IPostEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId
{
    attributes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId_Attributes;

    delete<TResponse>(options: { tenancy: string, id: number, publishToId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: number, publishToId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPatchEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPostEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPutEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.attributes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId_Attributes(context);
    }

    public attributes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId_Attributes;


    public async delete<TResponse>(options: { tenancy: string, id: number, publishToId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: number, publishToId: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPatchEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPostEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPutEventTypeEventHubForwarder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId_Attributes
{

    delete<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId_Attributes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_PublishTo_ByPublishToId_Attributes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}/attributes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: number, publishToId: number, body: IPayloadEventTypeEventHubForwarderEventFields[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/publish-to/${options.publishToId}/attributes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes
{
    set: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes_Set;

    get<TResponse>(options: { tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.set = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes_Set(context);
    }

    public set: FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes_Set;


    public async get<TResponse>(options: { tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/attributes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes_Set
{

    patch<TResponse>(options: { tenancy: string, id: string, body: ISetLinksPatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes_Set implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Entities_ById_Attributes_Set
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: ISetLinksPatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/entities/${options.id}/attributes/set?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid
{
    exportRequests: IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests;
    filters: IFadxPlatformApiClientV2_V2_ByNodeid_Filters;
    notes: IFadxPlatformApiClientV2_V2_ByNodeid_Notes;
    notificationReminders: IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders;
    shortcuts: IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts;
    supportedVersions: IFadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions;
    tag2Eventtype: IFadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype;
    tags: IFadxPlatformApiClientV2_V2_ByNodeid_Tags;


}

export class FadxPlatformApiClientV2_V2_ByNodeid implements IFadxPlatformApiClientV2_V2_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.exportRequests = new FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests(context);
        this.filters = new FadxPlatformApiClientV2_V2_ByNodeid_Filters(context);
        this.notes = new FadxPlatformApiClientV2_V2_ByNodeid_Notes(context);
        this.notificationReminders = new FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders(context);
        this.shortcuts = new FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts(context);
        this.supportedVersions = new FadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions(context);
        this.tag2Eventtype = new FadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype(context);
        this.tags = new FadxPlatformApiClientV2_V2_ByNodeid_Tags(context);
    }

    public exportRequests: FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests;
    public filters: FadxPlatformApiClientV2_V2_ByNodeid_Filters;
    public notes: FadxPlatformApiClientV2_V2_ByNodeid_Notes;
    public notificationReminders: FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders;
    public shortcuts: FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts;
    public supportedVersions: FadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions;
    public tag2Eventtype: FadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype;
    public tags: FadxPlatformApiClientV2_V2_ByNodeid_Tags;


}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests
{
    byId: IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById;
    cancel: IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_Cancel;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests implements IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById(context);
        this.cancel = new FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_Cancel(context);
    }

    public byId: FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById;
    public cancel: FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_Cancel;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById
{
    status: IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Status;
    download: IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Download;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById implements IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.status = new FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Status(context);
        this.download = new FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Download(context);
    }

    public status: FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Status;
    public download: FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Download;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Status
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Status implements IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Status
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/${options.id}/status?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Download
{

    get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Download implements IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_ById_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/${options.id}/download?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_Cancel
{

    patch<TResponse>(options: { nodeId: number, body: IExportRequestsCancelRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_Cancel implements IFadxPlatformApiClientV2_V2_ByNodeid_ExportRequests_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IExportRequestsCancelRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/export-requests/cancel?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Filters
{
    byFilterid: IFadxPlatformApiClientV2_V2_ByNodeid_Filters_ByFilterid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Filters implements IFadxPlatformApiClientV2_V2_ByNodeid_Filters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byFilterid = new FadxPlatformApiClientV2_V2_ByNodeid_Filters_ByFilterid(context);
    }

    public byFilterid: FadxPlatformApiClientV2_V2_ByNodeid_Filters_ByFilterid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/filters?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/filters?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Filters_ByFilterid
{

    delete<TResponse>(options: { nodeId: number, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Filters_ByFilterid implements IFadxPlatformApiClientV2_V2_ByNodeid_Filters_ByFilterid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filterid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, filterid: string, body: IFiltersRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/filters/${options.filterid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders
{
    byId: IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IIdentityProvidePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IIdentityProvidePostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById
{
    users: IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Users;
    roles: IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Roles;
    generateAccessToken: IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_GenerateAccessToken;
    syncExternalProvider: IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_SyncExternalProvider;

    delete<TResponse>(options: { tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: number, body: IIdentityPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.users = new FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Users(context);
        this.roles = new FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Roles(context);
        this.generateAccessToken = new FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_GenerateAccessToken(context);
        this.syncExternalProvider = new FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_SyncExternalProvider(context);
    }

    public users: FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Users;
    public roles: FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Roles;
    public generateAccessToken: FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_GenerateAccessToken;
    public syncExternalProvider: FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_SyncExternalProvider;


    public async delete<TResponse>(options: { tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: number, body: IIdentityPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Users
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Users implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}/users?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Roles
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Roles implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}/roles?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_GenerateAccessToken
{

    post<TResponse>(options: { tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_GenerateAccessToken implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_GenerateAccessToken
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}/generate-access-token?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_SyncExternalProvider
{

    post<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_SyncExternalProvider implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_IdentityProviders_ById_SyncExternalProvider
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/identity-providers/${options.id}/sync-external-provider?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes
{
    byNodeid: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid;
    download: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Download;
    import: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Import;

    get<TResponse>(options: { recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, virtualTreeView?: number, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNodeid = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid(context);
        this.download = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Download(context);
        this.import = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Import(context);
    }

    public byNodeid: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid;
    public download: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Download;
    public import: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Import;


    public async get<TResponse>(options: { recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, virtualTreeView?: number, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.virtualTreeView) { queryParts.push(`virtualTreeView=${encodeURIComponent(options.virtualTreeView)}`);}
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid
{
    solutions: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions;
    relationships: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Relationships;
    ontologyNodes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes;
    dataPoints: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints;
    spaceTypes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_SpaceTypes;
    availableOntologyNodes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_AvailableOntologyNodes;
    pathObjects: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathObjects;
    tree: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Tree;
    pathIdArray: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathIdArray;
    timezone: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Timezone;
    enable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Disable;

    delete<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, tenancy: string, body: IHierarchyNodesPatchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tenancy: string, body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.solutions = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions(context);
        this.relationships = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Relationships(context);
        this.ontologyNodes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes(context);
        this.dataPoints = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints(context);
        this.spaceTypes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_SpaceTypes(context);
        this.availableOntologyNodes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_AvailableOntologyNodes(context);
        this.pathObjects = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathObjects(context);
        this.tree = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Tree(context);
        this.pathIdArray = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathIdArray(context);
        this.timezone = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Timezone(context);
        this.enable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Disable(context);
    }

    public solutions: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions;
    public relationships: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Relationships;
    public ontologyNodes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes;
    public dataPoints: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints;
    public spaceTypes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_SpaceTypes;
    public availableOntologyNodes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_AvailableOntologyNodes;
    public pathObjects: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathObjects;
    public tree: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Tree;
    public pathIdArray: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathIdArray;
    public timezone: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Timezone;
    public enable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Disable;


    public async delete<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, tenancy: string, body: IHierarchyNodesPatchRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tenancy: string, body: IHierarchyNodesRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions
{
    bySolutionId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId;
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById;

    get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySolutionId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId(context);
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById(context);
    }

    public bySolutionId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId;
    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById;


    public async get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId
{
    enable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Disable;

    delete<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Disable(context);
    }

    public enable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Disable;


    public async delete<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions/${options.solutionId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions/${options.solutionId}?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Relationships
{

    delete<TResponse>(options: { nodeId: number, tenancy: string, body: INodeRelationshipPostPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, tenancy: string, body: INodeRelationshipPostPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Relationships implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Relationships
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, tenancy: string, body: INodeRelationshipPostPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/relationships?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/relationships?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, tenancy: string, body: INodeRelationshipPostPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/relationships?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes
{
    byOntologyNodeId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId;

    get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byOntologyNodeId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId(context);
    }

    public byOntologyNodeId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId;


    public async get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/ontology-nodes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId
{
    parameters: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId_Parameters;

    delete<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.parameters = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId_Parameters(context);
    }

    public parameters: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId_Parameters;


    public async delete<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/ontology-nodes/${options.ontologyNodeId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/ontology-nodes/${options.ontologyNodeId}?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, showDeletedRecords?: boolean, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, tenancy: string, body: IDataPointPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, showDeletedRecords?: boolean, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/data-points?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, tenancy: string, body: IDataPointPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/data-points?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById
{
    data: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById_Data;

    delete<TResponse>(options: { nodeId: number, id: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, showDeletedRecords?: boolean, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IDataPointPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.data = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById_Data(context);
    }

    public data: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById_Data;


    public async delete<TResponse>(options: { nodeId: number, id: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/data-points/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, showDeletedRecords?: boolean, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/data-points/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IDataPointPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/data-points/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Download
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Download implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_SpaceTypes
{

    get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_SpaceTypes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_SpaceTypes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/space-types?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById
{
    parameters: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById_Parameters;


}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.parameters = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById_Parameters(context);
    }

    public parameters: FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById_Parameters;


}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById_Parameters
{

    get<TResponse>(options: { nodeId: number, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IHierarchyNodeParameterModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById_Parameters implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_ById_Parameters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions/${options.id}/parameters?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tenancy: string, id: string, body: IHierarchyNodeParameterModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions/${options.id}/parameters?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId_Parameters
{

    get<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, body: IHierarchyNodeParameterModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId_Parameters implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_OntologyNodes_ByOntologyNodeId_Parameters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/ontology-nodes/${options.ontologyNodeId}/parameters?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tenancy: string, ontologyNodeId: string, body: IHierarchyNodeParameterModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/ontology-nodes/${options.ontologyNodeId}/parameters?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_AvailableOntologyNodes
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, showChildNodes?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_AvailableOntologyNodes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_AvailableOntologyNodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, showChildNodes?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.showChildNodes) { queryParts.push(`showChildNodes=${encodeURIComponent(options.showChildNodes)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/available-ontology-nodes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathObjects
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathObjects implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathObjects
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/path-objects?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Tree
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, virtualTreeViewId?: number, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Tree implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Tree
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tenancy: string, virtualTreeViewId?: number, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.virtualTreeViewId) { queryParts.push(`virtualTreeViewId=${encodeURIComponent(options.virtualTreeViewId)}`);}
            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/tree?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathIdArray
{

    get<TResponse>(options: { nodeId: number, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathIdArray implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_PathIdArray
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, tenancy: string, showDeletedRecords?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDeletedRecords) { queryParts.push(`showDeletedRecords=${encodeURIComponent(options.showDeletedRecords)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/path-id-array?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Timezone
{

    get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Timezone implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Timezone
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/timezone?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Enable
{

    patch<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Enable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/enable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Disable
{

    patch<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Disable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/disable?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Enable
{

    patch<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, body: ISimpleETagPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Enable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, body: ISimpleETagPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions/${options.solutionId}/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Disable
{

    patch<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, body: ISimpleETagPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Disable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_Solutions_BySolutionId_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, tenancy: string, solutionId: string, body: ISimpleETagPayload, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/solutions/${options.solutionId}/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Import
{

    post<TResponse>(options: { tenancy: string, genesis?: boolean, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Import implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_Import
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, genesis?: boolean, body: any, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.genesis) { queryParts.push(`genesis=${encodeURIComponent(options.genesis)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/import?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById_Data
{

    post<TResponse>(options: { nodeId: number, id: string, tenancy: string, body: IDataPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById_Data implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Nodes_ByNodeid_DataPoints_ById_Data
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { nodeId: number, id: string, tenancy: string, body: IDataPointVM, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/nodes/${options.nodeId}/data-points/${options.id}/data?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Notes
{
    byNoteid: IFadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid;
    download: IFadxPlatformApiClientV2_V2_ByNodeid_Notes_Download;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Notes implements IFadxPlatformApiClientV2_V2_ByNodeid_Notes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byNoteid = new FadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid(context);
        this.download = new FadxPlatformApiClientV2_V2_ByNodeid_Notes_Download(context);
    }

    public byNoteid: FadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid;
    public download: FadxPlatformApiClientV2_V2_ByNodeid_Notes_Download;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notes?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/notes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid
{
    cancel: IFadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel;

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, noteid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, noteid: string, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid implements IFadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.cancel = new FadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel(context);
    }

    public cancel: FadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel;


    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, noteid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notes/${options.noteid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, noteid: string, body: INotesRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/notes/${options.noteid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Notes_Download
{

    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, dataType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Notes_Download implements IFadxPlatformApiClientV2_V2_ByNodeid_Notes_Download
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, filter?: string, top?: number, dataType?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.dataType) { queryParts.push(`dataType=${encodeURIComponent(options.dataType)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notes/download?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IExportRequestsDto, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/notes/download?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel
{

    patch<TResponse>(options: { nodeId: number, noteid: string, body: INotesSoftDeleteRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel implements IFadxPlatformApiClientV2_V2_ByNodeid_Notes_ByNoteid_Cancel
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, noteid: string, body: INotesSoftDeleteRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/notes/${options.noteid}/cancel?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders
{
    byId: IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_ById;
    enable: IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Enable;
    disable: IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Disable;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders implements IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_ById(context);
        this.enable = new FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Disable(context);
    }

    public byId: FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_ById;
    public enable: FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Enable;
    public disable: FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Disable;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_ById
{

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_ById implements IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: INotificationReminder, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Enable
{

    patch<TResponse>(options: { nodeId: number, body: INotificationReminderEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Enable implements IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: INotificationReminderEnable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Disable
{

    patch<TResponse>(options: { nodeId: number, body: INotificationReminderDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Disable implements IFadxPlatformApiClientV2_V2_ByNodeid_NotificationReminders_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: INotificationReminderDisable[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/notification-reminders/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_ById;
    refresh: IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_Refresh;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostNotificationRule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_ById(context);
        this.refresh = new FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_Refresh(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_ById;
    public refresh: FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_Refresh;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/notification-rules?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostNotificationRule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/notification-rules?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_ById
{

    delete<TResponse>(options: { id: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, id: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { id: number, tenancy: string, body: IPutNotificationRule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { id: number, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/notification-rules/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, id: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/notification-rules/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { id: number, tenancy: string, body: IPutNotificationRule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/notification-rules/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_Refresh
{

    put<TResponse>(options: { id?: string, tenancy: string, body: IPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_Refresh implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_NotificationRules_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { id?: string, tenancy: string, body: IPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.id) { queryParts.push(`id=${encodeURIComponent(options.id)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/notification-rules/refresh?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IOntologyPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IOntologyPost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById
{
    nodes: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, body: IOntologyPatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: string, body: IOntologyPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.nodes = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes(context);
    }

    public nodes: FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, body: IOntologyPatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: string, body: IOntologyPut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes
{
    byOntologynodeid: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes_ByOntologynodeid;

    get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: string, body: IOntologyNodePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byOntologynodeid = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes_ByOntologynodeid(context);
    }

    public byOntologynodeid: FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes_ByOntologynodeid;


    public async get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}/nodes?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: string, body: IOntologyNodePost, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}/nodes?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes_ByOntologynodeid
{

    delete<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, body: IOntologyNodePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, body: IOntologyNodePut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes_ByOntologynodeid implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Ontologies_ById_Nodes_ByOntologynodeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}/nodes/${options.ontologynodeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}/nodes/${options.ontologynodeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, body: IOntologyNodePatch, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}/nodes/${options.ontologynodeid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: string, ontologynodeid: string, body: IOntologyNodePut, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/ontologies/${options.id}/nodes/${options.ontologynodeid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById
{
    solutions: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Solutions;
    enable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Disable;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, body: IPatchPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.solutions = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Solutions(context);
        this.enable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Disable(context);
    }

    public solutions: FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Solutions;
    public enable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Disable;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, body: IPatchPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Solutions
{

    get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Solutions implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Solutions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages/${options.id}/solutions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Enable
{

    patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Enable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages/${options.id}/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Disable
{

    patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Disable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Packages_ById_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchPackage, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/packages/${options.id}/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById
{
    enable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Disable;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, body: IPatchRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Disable(context);
    }

    public enable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Disable;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, body: IPatchRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Enable
{

    patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Enable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships/${options.id}/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Disable
{

    patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Disable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Relationships_ById_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchRelationshipParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/relationships/${options.id}/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles
{
    byId: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById;
    availableRights: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_AvailableRights;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IRolesPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById(context);
        this.availableRights = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_AvailableRights(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById;
    public availableRights: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_AvailableRights;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IRolesPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById
{
    deallocateUsers: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_DeallocateUsers;
    users: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_Users;
    roleDataSecurity: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_RoleDataSecurity;
    allocateUsers: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_AllocateUsers;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: string, body: IRolesPutRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.deallocateUsers = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_DeallocateUsers(context);
        this.users = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_Users(context);
        this.roleDataSecurity = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_RoleDataSecurity(context);
        this.allocateUsers = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_AllocateUsers(context);
    }

    public deallocateUsers: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_DeallocateUsers;
    public users: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_Users;
    public roleDataSecurity: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_RoleDataSecurity;
    public allocateUsers: FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_AllocateUsers;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: string, body: IRolesPutRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_DeallocateUsers
{

    delete<TResponse>(options: { tenancy: string, id: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_DeallocateUsers implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_DeallocateUsers
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}/deallocate-users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_Users
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_Users implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}/users?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_RoleDataSecurity
{

    get<TResponse>(options: { top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: string, body: IAdvancedSecurityEntityPutRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_RoleDataSecurity implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_RoleDataSecurity
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { top?: number, skipToken?: string, orderBy?: string, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderBy=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}/role-data-security?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: string, body: IAdvancedSecurityEntityPutRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}/role-data-security?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_AvailableRights
{

    get<TResponse>(options: { tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_AvailableRights implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_AvailableRights
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/AvailableRights?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_AllocateUsers
{

    post<TResponse>(options: { tenancy: string, id: string, body: IPostUserRoleModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_AllocateUsers implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Roles_ById_AllocateUsers
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostUserRoleModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/roles/${options.id}/allocate-users?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users
{
    schedule: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule;


}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Users implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.schedule = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule(context);
    }

    public schedule: FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule;


}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule
{
    byUserid: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid;
    overridestatus: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_Overridestatus;

    delete<TResponse>(options: { tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, body: IPutSchedule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byUserid = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid(context);
        this.overridestatus = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_Overridestatus(context);
    }

    public byUserid: FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid;
    public overridestatus: FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_Overridestatus;


    public async delete<TResponse>(options: { tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/users/schedule?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/users/schedule?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, body: IPutSchedule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/users/schedule?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid
{
    schedule: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid_Schedule;


}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.schedule = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid_Schedule(context);
    }

    public schedule: FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid_Schedule;


}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid_Schedule
{

    get<TResponse>(options: { select: new() => ODataSelect, userid: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { userid: string, tenancy: string, body: IPutSchedule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid_Schedule implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_ByUserid_Schedule
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, userid: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/users/schedule/${options.userid}/schedule?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { userid: string, tenancy: string, body: IPutSchedule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/users/schedule/${options.userid}/schedule?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_Overridestatus
{

    patch<TResponse>(options: { tenancy: string, body: IPatchSchedule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_Overridestatus implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Users_Schedule_Overridestatus
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, body: IPatchSchedule, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/users/schedule/overridestatus?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Scim
{
    users: IFadxPlatformApiClientV2_V2_Scim_Users;
    groups: IFadxPlatformApiClientV2_V2_Scim_Groups;
    schemas: IFadxPlatformApiClientV2_V2_Scim_Schemas;


}

export class FadxPlatformApiClientV2_V2_Scim implements IFadxPlatformApiClientV2_V2_Scim
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.users = new FadxPlatformApiClientV2_V2_Scim_Users(context);
        this.groups = new FadxPlatformApiClientV2_V2_Scim_Groups(context);
        this.schemas = new FadxPlatformApiClientV2_V2_Scim_Schemas(context);
    }

    public users: FadxPlatformApiClientV2_V2_Scim_Users;
    public groups: FadxPlatformApiClientV2_V2_Scim_Groups;
    public schemas: FadxPlatformApiClientV2_V2_Scim_Schemas;


}

export interface IFadxPlatformApiClientV2_V2_Scim_Users
{
    byId: IFadxPlatformApiClientV2_V2_Scim_Users_ById;

    get<TResponse>(options: { select?: string, filter?: string, sortBy?: string, startIndex?: number, count?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { body: IScimUser, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Scim_Users implements IFadxPlatformApiClientV2_V2_Scim_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Scim_Users_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Scim_Users_ById;


    public async get<TResponse>(options: { select?: string, filter?: string, sortBy?: string, startIndex?: number, count?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.select) { queryParts.push(`select=${encodeURIComponent(options.select)}`);}
            if (options.filter) { queryParts.push(`filter=${encodeURIComponent(options.filter)}`);}
            if (options.sortBy) { queryParts.push(`sortBy=${encodeURIComponent(options.sortBy)}`);}
            if (options.startIndex) { queryParts.push(`startIndex=${encodeURIComponent(options.startIndex)}`);}
            if (options.count) { queryParts.push(`count=${encodeURIComponent(options.count)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/scim/Users?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IScimUser, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/scim/Users?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Scim_Users_ById
{

    delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { id: string, body: IPatchRequest2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { id: string, body: IScimUser, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Scim_Users_ById implements IFadxPlatformApiClientV2_V2_Scim_Users_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/scim/Users/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/scim/Users/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { id: string, body: IPatchRequest2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/scim/Users/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { id: string, body: IScimUser, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/scim/Users/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Scim_Groups
{
    byId: IFadxPlatformApiClientV2_V2_Scim_Groups_ById;

    get<TResponse>(options: { excludedAttributes?: string, filter?: string, sortBy?: string, startIndex?: number, count?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { body: IScimGroup, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Scim_Groups implements IFadxPlatformApiClientV2_V2_Scim_Groups
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Scim_Groups_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Scim_Groups_ById;


    public async get<TResponse>(options: { excludedAttributes?: string, filter?: string, sortBy?: string, startIndex?: number, count?: number, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.excludedAttributes) { queryParts.push(`excludedAttributes=${encodeURIComponent(options.excludedAttributes)}`);}
            if (options.filter) { queryParts.push(`filter=${encodeURIComponent(options.filter)}`);}
            if (options.sortBy) { queryParts.push(`sortBy=${encodeURIComponent(options.sortBy)}`);}
            if (options.startIndex) { queryParts.push(`startIndex=${encodeURIComponent(options.startIndex)}`);}
            if (options.count) { queryParts.push(`count=${encodeURIComponent(options.count)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/scim/Groups?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IScimGroup, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/scim/Groups?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Scim_Groups_ById
{

    delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { id: string, excludedAttributes?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { id: string, body: IPatchRequest2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { id: string, body: IScimGroup, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Scim_Groups_ById implements IFadxPlatformApiClientV2_V2_Scim_Groups_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/scim/Groups/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { id: string, excludedAttributes?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.excludedAttributes) { queryParts.push(`excludedAttributes=${encodeURIComponent(options.excludedAttributes)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/scim/Groups/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { id: string, body: IPatchRequest2, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/scim/Groups/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { id: string, body: IScimGroup, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/scim/Groups/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Scim_Schemas
{

    get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Scim_Schemas implements IFadxPlatformApiClientV2_V2_Scim_Schemas
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/scim/Schemas?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts
{
    byId: IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById;
    refresh: IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Refresh;
    enable: IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Enable;
    disable: IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Disable;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts implements IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById(context);
        this.refresh = new FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Refresh(context);
        this.enable = new FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Disable(context);
    }

    public byId: FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById;
    public refresh: FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Refresh;
    public enable: FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Enable;
    public disable: FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Disable;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById
{
    refresh: IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh;

    delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, id: string, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById implements IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.refresh = new FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh(context);
    }

    public refresh: FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh;


    public async delete<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, id: string, body: IShortcutsRequestModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Refresh
{

    get<TResponse>(options: { nodeId: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Refresh implements IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, showDebugStats?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.showDebugStats) { queryParts.push(`showDebugStats=${encodeURIComponent(options.showDebugStats)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh
{

    get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh implements IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_ById_Refresh
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { nodeId: number, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/${options.id}/refresh?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Enable
{

    patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Enable implements IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Disable
{

    patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Disable implements IFadxPlatformApiClientV2_V2_ByNodeid_Shortcuts_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { nodeId: number, body: IShortcutsEnableRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/Shortcuts/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById
{
    parameters: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters;
    packages: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Packages;
    enable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disable;
    addpackage: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Addpackage;
    removepackage: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Removepackage;
    enablepackage: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enablepackage;
    disablepackage: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disablepackage;

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, body: IPatchSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.parameters = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters(context);
        this.packages = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Packages(context);
        this.enable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disable(context);
        this.addpackage = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Addpackage(context);
        this.removepackage = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Removepackage(context);
        this.enablepackage = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enablepackage(context);
        this.disablepackage = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disablepackage(context);
    }

    public parameters: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters;
    public packages: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Packages;
    public enable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disable;
    public addpackage: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Addpackage;
    public removepackage: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Removepackage;
    public enablepackage: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enablepackage;
    public disablepackage: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disablepackage;


    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, body: IPatchSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters
{
    byParameterId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId;

    get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, id: string, body: IPostHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byParameterId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId(context);
    }

    public byParameterId: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId;


    public async get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId
{
    enable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Disable;

    delete<TResponse>(options: { tenancy: string, id: string, parameterId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { tenancy: string, id: string, parameterId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: string, parameterId: string, body: IPatchHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Disable(context);
    }

    public enable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Disable;


    public async delete<TResponse>(options: { tenancy: string, id: string, parameterId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters/${options.parameterId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { tenancy: string, id: string, parameterId: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters/${options.parameterId}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: string, parameterId: string, body: IPatchHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters/${options.parameterId}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Packages
{

    get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Packages implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Packages
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/packages?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enable
{

    patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disable
{

    patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, body: IBasicPatchSolution, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Enable
{

    patch<TResponse>(options: { tenancy: string, id: string, parameterId: string, body: IBasicPatchHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Enable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, parameterId: string, body: IBasicPatchHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters/${options.parameterId}/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Disable
{

    patch<TResponse>(options: { tenancy: string, id: string, parameterId: string, body: IBasicPatchHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Disable implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Parameters_ByParameterId_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { tenancy: string, id: string, parameterId: string, body: IBasicPatchHierarchyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/parameters/${options.parameterId}/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Addpackage
{

    post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Addpackage implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Addpackage
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/addpackage?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Removepackage
{

    post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Removepackage implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Removepackage
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/removepackage?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enablepackage
{

    post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enablepackage implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Enablepackage
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/enablepackage?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disablepackage
{

    post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disablepackage implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_Solutions_ById_Disablepackage
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostSolution2Package, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/solutions/${options.id}/disablepackage?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions
{
    bySupportedversionid: IFadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions_BySupportedversionid;

    get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, schema?: boolean, body: ISupportedVersionPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions implements IFadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.bySupportedversionid = new FadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions_BySupportedversionid(context);
    }

    public bySupportedversionid: FadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions_BySupportedversionid;


    public async get<TResponse>(options: { nodeId: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/supported-versions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, schema?: boolean, body: ISupportedVersionPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/supported-versions?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions_BySupportedversionid
{

    delete<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, body: ISupportedVersionPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions_BySupportedversionid implements IFadxPlatformApiClientV2_V2_ByNodeid_SupportedVersions_BySupportedversionid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/supported-versions/${options.supportedversionid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/supported-versions/${options.supportedversionid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, supportedversionid: number, schema?: boolean, body: ISupportedVersionPutModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.schema) { queryParts.push(`schema=${encodeURIComponent(options.schema)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/supported-versions/${options.supportedversionid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype
{
    byTag2Eventtypeid: IFadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITag2EventTypeRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype implements IFadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTag2Eventtypeid = new FadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid(context);
    }

    public byTag2Eventtypeid: FadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITag2EventTypeRequest[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid
{

    delete<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, body: ITag2EventTypeRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid implements IFadxPlatformApiClientV2_V2_ByNodeid_Tag2Eventtype_ByTag2Eventtypeid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype/${options.tag2Eventtypeid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tag2Eventtypeid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype/${options.tag2Eventtypeid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, tag2Eventtypeid: string, body: ITag2EventTypeRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tag2eventtype/${options.tag2Eventtypeid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Tags
{
    byTagid: IFadxPlatformApiClientV2_V2_ByNodeid_Tags_ByTagid;

    get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { nodeId: number, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Tags implements IFadxPlatformApiClientV2_V2_ByNodeid_Tags
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byTagid = new FadxPlatformApiClientV2_V2_ByNodeid_Tags_ByTagid(context);
    }

    public byTagid: FadxPlatformApiClientV2_V2_ByNodeid_Tags_ByTagid;


    public async get<TResponse>(options: { nodeId: number, recursive?: boolean, select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.recursive) { queryParts.push(`recursive=${encodeURIComponent(options.recursive)}`);}
            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tags?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { nodeId: number, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/${options.nodeId}/tags?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_ByNodeid_Tags_ByTagid
{

    delete<TResponse>(options: { nodeId: number, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_ByNodeid_Tags_ByTagid implements IFadxPlatformApiClientV2_V2_ByNodeid_Tags_ByTagid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { nodeId: number, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { nodeId: number, select: new() => ODataSelect, tagid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, options.nodeId ?? 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { nodeId: number, tagid: string, body: ITagDefinitionsModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/${options.nodeId}/tags/${options.tagid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_Tenancies
{
    byId: IFadxPlatformApiClientV2_V2_Core_Tenancies_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { body: IPostTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_Tenancies implements IFadxPlatformApiClientV2_V2_Core_Tenancies
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_Tenancies_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_Tenancies_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/tenancies?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { body: IPostTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/tenancies?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_Tenancies_ById
{
    enable: IFadxPlatformApiClientV2_V2_Core_Tenancies_ById_Enable;
    disable: IFadxPlatformApiClientV2_V2_Core_Tenancies_ById_Disable;

    delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { id: string, body: IPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_Tenancies_ById implements IFadxPlatformApiClientV2_V2_Core_Tenancies_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.enable = new FadxPlatformApiClientV2_V2_Core_Tenancies_ById_Enable(context);
        this.disable = new FadxPlatformApiClientV2_V2_Core_Tenancies_ById_Disable(context);
    }

    public enable: FadxPlatformApiClientV2_V2_Core_Tenancies_ById_Enable;
    public disable: FadxPlatformApiClientV2_V2_Core_Tenancies_ById_Disable;


    public async delete<TResponse>(options: { id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/tenancies/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/tenancies/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { id: string, body: IPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/tenancies/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_Tenancies_ById_Enable
{

    patch<TResponse>(options: { id: string, body: IBasicPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_Tenancies_ById_Enable implements IFadxPlatformApiClientV2_V2_Core_Tenancies_ById_Enable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { id: string, body: IBasicPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/tenancies/${options.id}/enable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_Tenancies_ById_Disable
{

    patch<TResponse>(options: { id: string, body: IBasicPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_Tenancies_ById_Disable implements IFadxPlatformApiClientV2_V2_Core_Tenancies_ById_Disable
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async patch<TResponse>(options: { id: string, body: IBasicPatchTenancyParameter, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/tenancies/${options.id}/disable?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users
{
    preferences: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Preferences;
    byUserid: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid;
    byId: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById;
    applicationActions: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ApplicationActions;
    resetpassword: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Resetpassword;
    checkPin: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_CheckPin;
    getIdentityProvider: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_GetIdentityProvider;
    authenticate: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Authenticate;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IUserPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.preferences = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Preferences(context);
        this.byUserid = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid(context);
        this.byId = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById(context);
        this.applicationActions = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ApplicationActions(context);
        this.resetpassword = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Resetpassword(context);
        this.checkPin = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_CheckPin(context);
        this.getIdentityProvider = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_GetIdentityProvider(context);
        this.authenticate = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Authenticate(context);
    }

    public preferences: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Preferences;
    public byUserid: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid;
    public byId: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById;
    public applicationActions: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ApplicationActions;
    public resetpassword: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Resetpassword;
    public checkPin: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_CheckPin;
    public getIdentityProvider: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_GetIdentityProvider;
    public authenticate: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Authenticate;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IUserPostModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/users?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Preferences
{

    get<TResponse>(options: { tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, body: IUserPrefUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Preferences implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Preferences
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/preferences?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, body: IUserPrefUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/preferences?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid
{
    preferences: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Preferences;
    roles: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Roles;
    availableRoles: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_AvailableRoles;
    delegates: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Delegates;
    primaries: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Primaries;
    resetpassword: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Resetpassword;

    delete<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, userid: string, body: IUpdateUserModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.preferences = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Preferences(context);
        this.roles = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Roles(context);
        this.availableRoles = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_AvailableRoles(context);
        this.delegates = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Delegates(context);
        this.primaries = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Primaries(context);
        this.resetpassword = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Resetpassword(context);
    }

    public preferences: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Preferences;
    public roles: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Roles;
    public availableRoles: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_AvailableRoles;
    public delegates: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Delegates;
    public primaries: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Primaries;
    public resetpassword: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Resetpassword;


    public async delete<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, userid: string, body: IUpdateUserModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Preferences
{

    get<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, userid: string, body: IUserPrefUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Preferences implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Preferences
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/preferences?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, userid: string, body: IUserPrefUpdateModel, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/preferences?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById
{
    deallocateRoles: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_DeallocateRoles;
    allocateRoles: IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_AllocateRoles;


}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.deallocateRoles = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_DeallocateRoles(context);
        this.allocateRoles = new FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_AllocateRoles(context);
    }

    public deallocateRoles: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_DeallocateRoles;
    public allocateRoles: FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_AllocateRoles;


}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_DeallocateRoles
{

    delete<TResponse>(options: { tenancy: string, id: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_DeallocateRoles implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_DeallocateRoles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: string, body: string[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { data: options.body, ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.id}/deallocate-roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Roles
{

    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, userid: string, filter?: string, orderBy?: string, top?: number, skipToken?: string, memberTypeFilter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Roles implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Roles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, userid: string, filter?: string, orderBy?: string, top?: number, skipToken?: string, memberTypeFilter?: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`filter=${encodeURIComponent(options.filter)}`);}
            if (options.orderBy) { queryParts.push(`orderby=${encodeURIComponent(options.orderBy)}`);}
            if (options.top) { queryParts.push(`top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.memberTypeFilter) { queryParts.push(`memberTypeFilter=${encodeURIComponent(options.memberTypeFilter)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/roles?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_AvailableRoles
{

    get<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_AvailableRoles implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_AvailableRoles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/available-roles?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Delegates
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Delegates implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Delegates
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/delegates?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Primaries
{

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Primaries implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Primaries
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/primaries?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ApplicationActions
{

    get<TResponse>(options: { application?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ApplicationActions implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ApplicationActions
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async get<TResponse>(options: { application?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            if (options.application) { queryParts.push(`application=${encodeURIComponent(options.application)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/application-actions?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Resetpassword
{

    post<TResponse>(options: { tenancy: string, body: IUserResetCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Resetpassword implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Resetpassword
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, body: IUserResetCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/resetpassword?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_CheckPin
{

    post<TResponse>(options: { tenancy: string, body: IUserPin, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_CheckPin implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_CheckPin
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, body: IUserPin, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/check-pin?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_AllocateRoles
{

    post<TResponse>(options: { tenancy: string, id: string, body: IPostUserRoleModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_AllocateRoles implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ById_AllocateRoles
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, id: string, body: IPostUserRoleModel[], mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.id}/allocate-roles?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_GetIdentityProvider
{

    post<TResponse>(options: { tenancy: string, body: IGetUserIdentityProviderRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_GetIdentityProvider implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_GetIdentityProvider
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, body: IGetUserIdentityProviderRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/get-identity-provider?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_Users
{
    getIdentityProvider: IFadxPlatformApiClientV2_V2_Security_Users_GetIdentityProvider;
    authenticate: IFadxPlatformApiClientV2_V2_Security_Users_Authenticate;


}

export class FadxPlatformApiClientV2_V2_Security_Users implements IFadxPlatformApiClientV2_V2_Security_Users
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.getIdentityProvider = new FadxPlatformApiClientV2_V2_Security_Users_GetIdentityProvider(context);
        this.authenticate = new FadxPlatformApiClientV2_V2_Security_Users_Authenticate(context);
    }

    public getIdentityProvider: FadxPlatformApiClientV2_V2_Security_Users_GetIdentityProvider;
    public authenticate: FadxPlatformApiClientV2_V2_Security_Users_Authenticate;


}

export interface IFadxPlatformApiClientV2_V2_Security_Users_GetIdentityProvider
{

    post<TResponse>(options: { body: IGetUserIdentityProviderRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_Users_GetIdentityProvider implements IFadxPlatformApiClientV2_V2_Security_Users_GetIdentityProvider
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IGetUserIdentityProviderRequest, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/users/get-identity-provider?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_Users_Authenticate
{

    post<TResponse>(options: { body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_Users_Authenticate implements IFadxPlatformApiClientV2_V2_Security_Users_Authenticate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/users/authenticate?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Authenticate
{

    post<TResponse>(options: { tenancy: string, body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Authenticate implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_Authenticate
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async post<TResponse>(options: { tenancy: string, body: IUserCredentials, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/authenticate?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Resetpassword
{

    put<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Resetpassword implements IFadxPlatformApiClientV2_V2_Security_ByTenancy_Users_ByUserid_Resetpassword
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async put<TResponse>(options: { tenancy: string, userid: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/security/${options.tenancy}/users/${options.userid}/resetpassword?${query}`, undefined, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews
{
    byId: IFadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews_ById;

    get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    post<TResponse>(options: { tenancy: string, body: IPostVirtualTreeView, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
        this.byId = new FadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews_ById(context);
    }

    public byId: FadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews_ById;


    public async get<TResponse>(options: { select: new() => ODataSelect, filter?: string, top?: number, skipToken?: string, orderBy?: string, tenancy: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);
            queryParts.push(`$expand=${encodeURIComponent(new options.select().toExpand())}`);
            if (options.filter) { queryParts.push(`$filter=${encodeURIComponent(options.filter)}`);}
            if (options.top) { queryParts.push(`$top=${encodeURIComponent(options.top)}`);}
            if (options.skipToken) { queryParts.push(`$skipToken=${encodeURIComponent(options.skipToken)}`);}
            if (options.orderBy) { queryParts.push(`$orderby=${encodeURIComponent(options.orderBy)}`);}

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/virtual-tree-views?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async post<TResponse>(options: { tenancy: string, body: IPostVirtualTreeView, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.post(`${this.context.baseUrl}/v2/core/${options.tenancy}/virtual-tree-views?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IFadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews_ById
{

    delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    patch<TResponse>(options: { tenancy: string, id: number, body: IPatchVirtualTreeView, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;
    put<TResponse>(options: { tenancy: string, id: number, body: IPutVirtualTreeView, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>;

}

export class FadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews_ById implements IFadxPlatformApiClientV2_V2_Core_ByTenancy_VirtualTreeViews_ById
{
    private context: IContext;

    constructor(context: IContext)
    {
        this.context = context;
    }



    public async delete<TResponse>(options: { tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.delete(`${this.context.baseUrl}/v2/core/${options.tenancy}/virtual-tree-views/${options.id}?${query}`, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async get<TResponse>(options: { select: new() => ODataSelect, tenancy: string, id: string, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;

            queryParts.push(`$select=${encodeURIComponent(new options.select().toSelect())}`);

            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.get(`${this.context.baseUrl}/v2/core/${options.tenancy}/virtual-tree-views/${options.id}?${query}`, config);
            const mapItem = (item: any) => new options.select().init(item, 1);
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, mapItem);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async patch<TResponse>(options: { tenancy: string, id: number, body: IPatchVirtualTreeView, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.patch(`${this.context.baseUrl}/v2/core/${options.tenancy}/virtual-tree-views/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

    public async put<TResponse>(options: { tenancy: string, id: number, body: IPutVirtualTreeView, mapResponse?: (response: AxiosResponse<any>) => TResponse, suppressErrorPopup?: boolean, requestConfig?: IbssRequestConfig }): Promise<TResponse>
    {
        try
        {
            const queryParts = new Array<string>;


            const query = queryParts.join('&');
            const config: IbssRequestConfig = { ...options.requestConfig, suppressErrorPopup: options.suppressErrorPopup ?? false };
            const response = await axios.put(`${this.context.baseUrl}/v2/core/${options.tenancy}/virtual-tree-views/${options.id}?${query}`, options.body, config);
            
            const typedResponse = ApiHelper.toTypedResponse(response.data, options.mapResponse, undefined);
            return typedResponse;
        }
        catch (error)
        {
            throw ApiError.fromAxiosError(error as AxiosError);
        }
    }

}

export interface IPostEventField
{
    Name?: string | null;
    EventTypeName?: string | null;
    EventGroupName?: string | null;
    EventGroupID?: number | null;
    IsArray?: boolean | null;
    IsMandatory?: boolean | null;
    BuiltInType?: BuiltInType;
    ValidationFunctionParameter?: string | null;
    ValidationFunctionName?: string | null;
    Package_ID?: string | null;

}

export type BuiltInType = 'Void' | 'Char' | 'Int16' | 'Int32' | 'Int64' | 'Byte' | 'UInt16' | 'UInt32' | 'UInt64' | 'Single' | 'Double' | 'Boolean' | 'String' | 'TypeInfo' | 'Status' | 'DateTime' | 'Guid' | 'SByte' | 'Decimal' | 'TimeSpan';

export interface IPutEventField
{
    Name?: string | null;
    EventTypeName?: string | null;
    EventGroupName?: string | null;
    EventGroupID?: number | null;
    IsArray?: boolean | null;
    IsMandatory?: boolean | null;
    BuiltInType?: BuiltInType;
    ValidationFunctionParameter?: string | null;
    ValidationFunctionName?: string | null;

}

export interface IPostDataHubCredentials
{
    Name?: string | null;
    DisplayName?: string | null;
    ConnectionString?: string | null;
    AccessKey?: string | null;

}

export interface IPatchDataHubCredential
{
    Name?: string | null;
    DisplayName?: string | null;
    ConnectionString?: string | null;
    AccessKey?: string | null;
    ['@odata.etag']?: string | null;

}

export interface IPutDataHubCredential
{
    Name?: string;
    DisplayName?: string | null;
    ConnectionString?: string | null;
    AccessKey?: string | null;
    ['@odata.etag']?: string;

}

export interface IPostDataHubPublisher
{
    Name?: string | null;
    DisplayName?: string | null;
    DataHubCredential_Id?: number;
    ModuleConfiguration_Id?: string | null;
    PublishingType?: ForwarderTypeEnum;

}

export type ForwarderTypeEnum = 'EventHub' | 'EventGrid' | 'AzureFunction';

export interface IPatchDataHubPublisher
{
    Name?: string | null;
    DisplayName?: string | null;
    DataHubCredential_Id?: number | null;
    ModuleConfiguration_Id?: string | null;
    PublishingType?: ForwarderTypeEnum;
    ['@odata.etag']?: string | null;

}

export interface IPutDataHubPublisher
{
    Name?: string;
    DisplayName?: string | null;
    DataHubCredential_Id?: number;
    ModuleConfiguration_Id?: string | null;
    PublishingType?: ForwarderTypeEnum;
    ['@odata.etag']?: string;

}

export interface IPatchEventTypeEventHubForwarder
{
    Name?: string | null;
    EventTypeId?: number | null;
    DataPublisher_Id?: number | null;
    ForwardType?: ForwardEventEnum;
    Topic?: string | null;
    ['@odata.etag']?: string | null;

}

export type ForwardEventEnum = 'None' | 'Whole' | 'SelectedFields' | 'SelectedFieldsOnChange' | 'ChangedFieldsOnChange' | 'Internal';

export interface IPostEventTypeEventHubForwarder
{
    Name?: string | null;
    DataPublisher_Id?: number;
    ForwardType?: ForwardEventEnum;
    Topic?: string | null;

}

export interface IPutEventTypeEventHubForwarder
{
    Name?: string;
    EventTypeId?: number;
    DataPublisher_Id?: number;
    ForwardType?: ForwardEventEnum;
    Topic?: string;
    ['@odata.etag']?: string;

}

export interface IPayloadEventTypeEventHubForwarderEventFields
{
    EventFieldId?: number;

}

export interface IDataPointPost
{
    Name?: string | null;
    DisplayName?: string | null;
    SortOrder?: number;
    IsEnabled?: YesNoEnum;
    DataPointType?: number;
    DataPointDataType?: number;
    ValidationRangeMinimum?: string | null;
    ValidationRangeMaximum?: string | null;
    ValidationRule?: string | null;
    DataCollectionDeviceId?: string | null;
    DataPointName?: string | null;

}

export type YesNoEnum = 'No' | 'Yes';

export interface IDataPointPut
{
    Name?: string | null;
    DisplayName?: string | null;
    SortOrder?: number;
    IsEnabled?: YesNoEnum;
    DataPointType?: number;
    DataPointDataType?: number;
    ValidationRangeMinimum?: string | null;
    ValidationRangeMaximum?: string | null;
    ValidationRule?: string | null;
    DataCollectionDeviceId?: string | null;
    DataPointName?: string | null;
    ConcurrencyStamp?: string | null;

}

export interface IDataPointVM
{
    Value?: string | null;
    ValueTimestamp?: string | null;

}

export interface IDelegateRequest
{
    PrimaryUser_Id?: string | null;
    PrimaryUserName?: string | null;
    PrimaryEmail?: string | null;
    PrimaryOID?: string | null;
    DelegateUser_Id?: string | null;
    DelegateUserName?: string | null;
    DelegateEmail?: string | null;
    DelegateOID?: string | null;
    Scope?: number;

}

export interface IEventTypePost
{
    Name?: string | null;
    HistoryStorageMethod?: HistoryStorageMethodEnum;
    StorageType?: StorageTypeEnum;
    AuditLogDisabled?: number;
    DisplayName?: string | null;
    Package_ID?: string | null;

}

export type HistoryStorageMethodEnum = 'None' | 'CosmosFullHistory' | 'CosmosSingleRecordHistory' | 'Audit';

export type StorageTypeEnum = 'Cosmos' | 'SQL' | 'ADT';

export interface IEventTypePatch
{
    Name?: string | null;
    HistoryStorageMethod?: HistoryStorageMethodEnum;
    StorageType?: StorageTypeEnum;
    AuditLogDisabled?: number | null;
    DisplayName?: string | null;

}

export interface ISetLinksPatch
{
    EventPrimaryKeyField_ID?: number;
    EventTimeField_ID?: number;
    EventFieldIds?: number[] | null;
    EventFieldFunctions?: string[] | null;
    EventFieldExpressions?: string[] | null;
    InputAliases?: string[] | null;
    IndexedColumnIds?: number[] | null;

}

export interface IExportRequestsCancelRequest
{
    Request_Id?: string | null;

}

export interface IFiltersRequest
{
    Filter_Id?: string | null;
    EventType_Id?: number;
    Filter?: string | null;
    Status?: string | null;
    Building_Bypass?: boolean | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface IIdentityProvidePostModel
{
    SecurityProviderTypeId?: number;
    MinPasswordLength?: number | null;
    MaxPasswordAge?: number | null;
    PasswordComplexity?: number | null;
    ClientId?: string | null;
    TenantDomain?: string | null;
    TenantId?: string | null;
    ClientSecret?: string | null;
    Name?: string | null;
    DisplayName?: string | null;
    AdditionalAudiences?: string | null;
    NameClaimType?: string | null;
    IsDefault?: boolean;
    SyncType?: SyncTypeEnum;
    TenancyId?: string | null;

}

export type SyncTypeEnum = 'None' | 'GraphAPI' | 'SCIMv2' | 'GroupsClaimSync';

export interface IIdentityPutModel
{
    SecurityProviderTypeId?: number | null;
    ClientId?: string | null;
    TenantDomain?: string | null;
    MinPasswordLength?: number | null;
    MaxPasswordAge?: number | null;
    PasswordComplexity?: number | null;
    TenantId?: string | null;
    ClientSecret?: string | null;
    Name?: string | null;
    DisplayName?: string | null;
    AdditionalAudiences?: string | null;
    NameClaimType?: string | null;
    IsDefault?: boolean | null;
    SyncType?: SyncTypeEnum;
    ConcurrencyStamp?: string | null;

}

export interface IHierarchyNodesRequest
{
    ID?: number;
    Name?: string | null;
    Deleted?: boolean;
    DisplayName?: string | null;
    Parent_ID?: number | null;
    TimeZoneDST?: number | null;
    IsEnabled?: number | null;
    SortOrder?: string | null;
    Level?: string | null;
    TimeZone?: string | null;
    TimeZoneType?: string | null;
    MapURI?: string | null;
    ImageURI?: string | null;
    Agents?: IAgents;
    Physical_Properties?: IPhysicalProperties;
    Node_Search_Config?: INode_Search_Config;
    Location?: ILocation;

}

export interface IAgents
{
    Owner?: string | null;
    Operator?: string | null;
    Occupier?: string | null;

}

export interface IPhysicalProperties
{
    Capacity?: string | null;
    Size?: string | null;

}

export interface INode_Search_Config
{
    config?: string | null;

}

export interface ILocation
{
    Address?: string | null;
    City?: string | null;
    Country?: string | null;
    Longitude?: string | null;
    Latitude?: string | null;

}

export interface IHierarchyNodesPatchRequest
{
    ID?: number;
    Name?: string | null;
    Deleted?: boolean;
    DisplayName?: string | null;
    Parent_ID?: number | null;
    IsEnabled?: number | null;
    SortOrder?: string | null;
    Level?: string | null;
    TimeZone?: string | null;
    TimeZoneType?: string | null;
    TimeZoneDST?: number | null;
    MapURI?: string | null;
    ImageURI?: string | null;
    Agents?: IAgents;
    Physical_Properties?: IPhysicalProperties;
    Node_Search_Config?: INode_Search_Config;
    Location?: ILocation;

}

export interface INodeRelationshipPostPayload
{
    SecondaryNodeid?: number;
    RelationshipId?: string | null;

}

export interface IHierarchyNodeParameterModel
{
    ['@odata.etag']?: string | null;
    ID?: string | null;
    Value?: string | null;

}

export interface ISimpleETagPayload
{
    ['@odata.etag']?: string | null;

}

export interface INotesRequestModel
{
    Note_Id?: string | null;
    Node_Id?: number;
    EventType_Id?: number;
    Event_Id?: string | null;
    EventType_Name?: string | null;
    Note?: string | null;
    IsDeleted?: number;

}

export interface IExportRequestsDto
{
    Node_Id?: number;
    Select?: string | null;
    Filter?: string | null;
    Top?: number;
    Source?: string | null;

}

export interface INotesSoftDeleteRequest
{
    IsDeleted?: number;

}

export interface INotificationReminder
{
    EventType_Id?: number;
    Status?: string | null;
    NotificationDuration?: string | null;
    TimeOfDay?: string | null;
    Filter?: string | null;
    BuiltInRule?: number;
    CustomData?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface INotificationReminderEnable
{
    Reminder_Id?: string | null;

}

export interface INotificationReminderDisable
{
    Reminder_Id?: string | null;

}

export interface IPostNotificationRule
{
    Name?: string | null;
    Disabled?: boolean;
    EventTypeName?: string | null;
    RuleExpression?: string | null;
    NotificationArea?: NotificationAreaEnum;
    ShouldSendMail?: boolean | null;
    To?: string | null;
    Cc?: string | null;
    Bcc?: string | null;
    ReplyTo?: string | null;
    Subject?: string | null;
    Message?: string | null;
    IsHTML?: boolean | null;
    AttachmentType?: NotificationRuleAttachmentTypeEnum;
    ShouldSendMobilePush?: boolean | null;
    MobilePushMessage?: string | null;
    MobilePushTo?: string | null;
    MobilePushTitle?: string | null;
    MobilePushAction?: string | null;
    MobilePushActionUri?: string | null;
    MobilePushBadge?: string | null;
    ShouldSendTwilio?: boolean | null;
    TwilioMessage?: string | null;
    TwilioTo?: string | null;

}

export type NotificationAreaEnum = 'Generic' | 'IBSS_Visitors' | 'IBSS_Bookings' | 'IBSS_Tasks';

export type NotificationRuleAttachmentTypeEnum = 'None' | 'All' | 'Office' | 'OfficeAll';

export interface IPutNotificationRule
{
    Name?: string;
    Disabled?: boolean;
    EventTypeName?: string | null;
    RuleExpression?: string | null;
    NotificationArea?: NotificationAreaEnum;
    ShouldSendMail?: boolean;
    To?: string | null;
    Cc?: string | null;
    Bcc?: string | null;
    ReplyTo?: string | null;
    Subject?: string | null;
    Message?: string | null;
    IsHTML?: boolean;
    AttachmentType?: NotificationRuleAttachmentTypeEnum;
    ShouldSendMobilePush?: boolean;
    MobilePushMessage?: string | null;
    MobilePushTo?: string | null;
    MobilePushTitle?: string | null;
    MobilePushAction?: string | null;
    MobilePushActionUri?: string | null;
    MobilePushBadge?: string | null;
    ShouldSendTwilio?: boolean;
    TwilioMessage?: string | null;
    TwilioTo?: string | null;
    ConcurrencyStamp?: string;

}

export interface IPatchTenancyParameter
{
    Name?: string | null;
    DisplayName?: string | null;
    IsEnabled?: YesNoEnum;
    Root_NodeId?: string | null;
    ['@odata.etag']?: string | null;

}

export interface IOntologyPost
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;

}

export interface IOntologyPatch
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IOntologyPut
{
    Name?: string;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IOntologyNodePost
{
    Name?: string | null;
    DisplayName?: string | null;
    IsEnabled?: YesNoEnum;
    IsRecursive?: YesNoEnum;
    Parent_ID?: string | null;
    IsRequired?: YesNoEnum;

}

export interface IOntologyNodePatch
{
    Name?: string | null;
    DisplayName?: string | null;
    IsRecursive?: YesNoEnum;
    Parent_ID?: string | null;
    IsRequired?: YesNoEnum;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IOntologyNodePut
{
    Name?: string | null;
    DisplayName?: string | null;
    IsRecursive?: YesNoEnum;
    Parent_ID?: string | null;
    IsRequired?: YesNoEnum;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IPostPackage
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;

}

export interface IPatchPackage
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IBasicPatchPackage
{
    ['@odata.etag']?: string | null;

}

export interface IPostRelationshipParameter
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    Primary2SecondaryRelation?: string | null;
    Secondary2PrimaryRelation?: string | null;

}

export interface IPatchRelationshipParameter
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    Primary2SecondaryRelation?: string | null;
    Secondary2PrimaryRelation?: string | null;
    ['@odata.etag']?: string | null;

}

export interface IBasicPatchRelationshipParameter
{
    ['@odata.etag']?: string | null;

}

export interface IRolesPostModel
{
    Name?: string | null;
    DisplayName?: string | null;
    GroupId?: string | null;
    ApplicationActions?: string | null;
    IdentityProviderId?: number | null;
    ExternalId?: string | null;
    IsOwner?: number;
    Email?: string | null;
    TenancyId?: string | null;

}

export interface IRolesPutRequest
{
    Name?: string | null;
    DisplayName?: string | null;
    GroupId?: string | null;
    ApplicationActions?: string | null;
    ['@odata.etag']?: string | null;
    IdentityProviderId?: number | null;
    IsOwner?: number;
    Email?: string | null;

}

export interface IAdvancedSecurityEntityPutRequest
{
    Id?: number;
    Append?: number;
    AppendTo?: number;
    Read?: number;
    Update?: number;
    Create?: number;
    Delete?: number;
    Lock?: number;
    Unlock?: number;
    Share?: number;

}

export interface IPostUserRoleModel
{
    Id?: string | null;
    MemberType?: MemberTypeEnum;

}

export type MemberTypeEnum = 'Standard' | 'Member' | 'Owner' | 'TeamLeader';

export interface IPutSchedule
{
    WeeklySchedule?: IDaySchedule[] | null;
    ConcurrencyStamp?: string | null;

}

export interface IDaySchedule
{
    WorkDay?: DaysEnum;
    Sessions?: ISession[] | null;

}

export type DaysEnum = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';

export interface ISession
{
    StartTime?: string;
    EndTime?: string;
    Location?: LocationsEnum;

}

export type LocationsEnum = 'Remote' | 'Office' | 'OutOfOffice';

export interface IPatchSchedule
{
    StatusOverride?: IPatchScheduleStatus;

}

export interface IPatchScheduleStatus
{
    Location?: LocationsEnum;

}

export interface IScimUser
{
    schemas?: string[] | null;
    id?: string | null;
    userName?: string | null;
    externalId?: string | null;
    displayName?: string | null;
    title?: string | null;
    locale?: string | null;
    ['urn:ietf:params:scim:schemas:extension:enterprise:2.0:User']?: IEnterpriseScimUser;
    Department?: string | null;
    active?: boolean;
    emails?: IScimEmail[] | null;
    phoneNumbers?: IScimPhoneNumber[] | null;
    meta?: IScimMeta;
    name?: IScimName;

}

export interface IEnterpriseScimUser
{
    department?: string | null;

}

export interface IScimEmail
{
    value?: string | null;
    type?: string | null;
    primary?: boolean;

}

export interface IScimPhoneNumber
{
    value?: string | null;
    display?: string | null;
    type?: string | null;
    primary?: boolean | null;

}

export interface IScimMeta
{
    resourceType?: string | null;
    location?: string | null;
    created?: string | null;
    lastModified?: string | null;

}

export interface IScimName
{
    givenName?: string | null;
    familyName?: string | null;
    formatted?: string | null;

}

export interface IPatchRequest2
{
    schemas?: string[];
    Operations?: IPatchOperation2Combined[];

}

export interface IPatchOperation2Combined
{
    op?: string | null;
    path?: string;
    value?: any;

}

export interface IScimGroup
{
    schemas?: string[] | null;
    id?: string | null;
    externalId?: string | null;
    displayName?: string | null;
    members?: IScimMember[] | null;
    meta?: IScimMeta;

}

export interface IScimMember
{
    value?: string | null;
    display?: string | null;
    $ref?: string | null;

}

export interface IShortcutsRequestModel
{
    SignPostType?: string | null;
    KPIType?: number | null;
    Units?: string | null;
    Label?: string | null;
    MaximumCount?: number | null;
    BuildingKPI_Limit1?: number | null;
    BuildingKPI_Limit2?: number | null;
    BuildingKPI_Text0?: string | null;
    BuildingKPI_Text1?: string | null;
    BuildingKPI_Text2?: string | null;
    BuildingKPI_Value?: number | null;
    ValueURI?: string | null;
    Icon?: string | null;
    ActionLabel?: string | null;
    ActionURI?: string | null;
    BuildingKPI_Order?: number | null;
    Heading?: string | null;
    SubHeading?: string | null;
    Application?: string[] | null;
    Image?: string | null;
    StartDate?: string | null;
    EndDate?: string | null;
    Destination?: IDestination;
    IsEnabled?: number | null;

}

export interface IDestination
{
    Web?: string | null;
    Android?: string | null;
    iOS?: string | null;

}

export interface IShortcutsEnableRequest
{
    ShortcutIds?: string[] | null;

}

export interface IPostSolution
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    Ontology_ID?: string | null;
    ImageUri?: string | null;
    IconUri?: string | null;
    ApplicationUri?: string | null;
    OrderSequence?: number | null;
    ShowOnHomePage?: YesNoEnum;
    ShowOnMenu?: YesNoEnum;

}

export interface IPatchSolution
{
    Name?: string | null;
    DisplayName?: string | null;
    Description?: string | null;
    Ontology_ID?: string | null;
    ImageUri?: string | null;
    IconUri?: string | null;
    ApplicationUri?: string | null;
    OrderSequence?: number | null;
    IsEnabled?: YesNoEnum;
    ShowOnHomePage?: YesNoEnum;
    ShowOnMenu?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IPostHierarchyParameter
{
    Name?: string | null;
    ValueType?: BuiltInType;
    IsEnabled?: YesNoEnum;
    OntologyNode_ID?: string | null;

}

export interface IPatchHierarchyParameter
{
    Name?: string | null;
    ValueType?: BuiltInType;
    OntologyNode_ID?: string | null;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string | null;

}

export interface IBasicPatchSolution
{
    ['@odata.etag']?: string | null;

}

export interface IBasicPatchHierarchyParameter
{
    ['@odata.etag']?: string | null;

}

export interface IPostSolution2Package
{
    Package_ID?: string | null;

}

export interface ISupportedVersionPostModel
{
    Supported_Version_OS?: number;
    Supported_Version_Module?: number;
    Supported_Version?: string | null;
    Supported_Version_Date?: string;

}

export interface ISupportedVersionPutModel
{
    Supported_Version_OS?: number | null;
    Supported_Version_Module?: number | null;
    Supported_Version?: string | null;
    Supported_Version_Date?: string | null;

}

export interface ITag2EventTypeRequest
{
    Tag2EventType_Id?: string | null;
    Tag_Id?: string | null;
    EventType_Id?: number;
    TagType?: string | null;
    Name?: string | null;
    Value?: string | null;
    Icon?: string | null;
    Node_Id?: number;
    Record_Id?: string | null;
    CreatedBy?: string | null;
    CreatedAt?: string;
    ModifiedBy?: string | null;
    ModifiedAt?: string;

}

export interface ITagDefinitionsModel
{
    Tag_Id?: string | null;
    TagType?: string | null;
    Values?: string | null;
    Icon?: string | null;
    Description?: string | null;
    Status?: string | null;
    Node_Id?: number | null;
    Name?: string | null;
    ConcurrencyStamp?: string | null;
    OwnedByUserId?: string | null;
    OwnedByRoleId?: string | null;
    CreatedByUserId?: string | null;
    ModifiedByUserId?: string | null;
    TenancyId?: string | null;

}

export interface IPostTenancyParameter
{
    Name?: string | null;
    DisplayName?: string | null;
    IsEnabled?: YesNoEnum;
    Root_NodeId?: string | null;

}

export interface IBasicPatchTenancyParameter
{
    ['@odata.etag']?: string | null;

}

export interface IUserPostModel
{
    FirstName?: string | null;
    LastName?: string | null;
    DisplayName?: string | null;
    OID?: string | null;
    Email?: string | null;
    Password?: string | null;
    PhoneNumber?: string | null;
    IdentityProviderId?: number;
    UserPreferences?: string | null;
    UserLocation?: string | null;
    PasswordHash?: string | null;
    UserType?: number;
    TenancyId?: string | null;
    PreferredName?: string | null;
    UserInitials?: string | null;

}

export interface IUserPrefUpdateModel
{
    HubPrefs?: IHubPrefs;
    SecurityPrefs?: ISecurityPrefs;
    NotificationPrefs?: INotificationPreference;
    PrivacyPrefs?: IPrivacyPreference;
    CalendarPrefs?: ICalendarPreference;
    EnvironmentPrefs?: IEnvironmentPreference;
    WorkinghoursPrefs?: IWorkingHoursPreference;
    SearchPrefs?: ISearchPreference;
    DiagnosticsPrefs?: IDiagnosticsPreference;
    LanguagePrefs?: ILanguagePrefs;
    Nodes?: IBuilding[] | null;
    FavouriteColleagues?: IFavouriteColleague[] | null;
    DefaultBookingCostCodes?: ICostCodeAttribute[] | null;
    DefaultCateringCostCodes?: ICostCodeAttribute[] | null;

}

export interface IHubPrefs
{
    StartApp?: string | null;
    TimeMode?: string | null;

}

export interface ISecurityPrefs
{
    Pin?: string | null;

}

export interface INotificationPreference
{
    Safety?: number | null;
    Visitors?: number | null;
    Tasks?: number | null;
    Bookings?: number | null;
    Buildings?: number | null;
    DeviceRegistrationId?: string | null;
    Platform?: string | null;
    Handle?: string | null;
    BuildingsPrefs?: IBuildingsPrefs[] | null;

}

export interface IBuildingsPrefs
{
    NodeId?: number | null;
    Value?: number | null;

}

export interface IPrivacyPreference
{
    ShareLocation?: number | null;

}

export interface ICalendarPreference
{
    SyncCalendar?: number | null;

}

export interface IEnvironmentPreference
{
    Temperature?: number | null;
    SoundLevel?: number | null;

}

export interface IWorkingHoursPreference
{
    UserStartTime?: string | null;
    UserEndTime?: string | null;

}

export interface ISearchPreference
{
    DefaultSearchResults?: string | null;
    DefaultBuilding?: number | null;

}

export interface IDiagnosticsPreference
{
    Logging?: number | null;

}

export interface ILanguagePrefs
{
    Language?: string | null;

}

export interface IBuilding
{
    NodeId?: number | null;
    DefaultFloor?: number | null;
    DefaultZone?: string | null;
    FavouriteSpaces?: string[] | null;
    FavouriteAmenities?: string[] | null;
    FavouriteEquipment?: string[] | null;
    DefaultFilter?: IDefaultFilter[] | null;

}

export interface IDefaultFilter
{
    EventType_Id?: string | null;
    Filter_Id?: string | null;

}

export interface IFavouriteColleague
{
    Email?: string | null;
    FirstName?: string | null;
    LastName?: string | null;

}

export interface ICostCodeAttribute
{
    CostCodeID?: string | null;
    CostCodeName?: string | null;
    CostCodeDescription?: string | null;
    CostCodeApportionment?: string | null;

}

export interface IUpdateUserModel
{
    FirstName?: string | null;
    LastName?: string | null;
    DisplayName?: string | null;
    OID?: string | null;
    Deleted?: boolean;
    Email?: string | null;
    PhoneNumber?: string | null;
    UserPreferences?: string | null;
    UserLocation?: string | null;
    ConcurrencyStamp?: string | null;
    IdentityProviderId?: number | null;
    PreferredName?: string | null;
    UserInitials?: string | null;

}

export interface IUserResetCredentials
{
    Email?: string | null;
    OldPassword?: string | null;
    NewPassword?: string | null;

}

export interface IUserPin
{
    PIN?: string | null;
    UserName?: string | null;

}

export interface IGetUserIdentityProviderRequest
{
    username?: string | null;

}

export interface IUserCredentials
{
    Username?: string | null;
    Password?: string | null;

}

export interface IPostVirtualTreeView
{
    Name?: string | null;
    DisplayName?: string | null;
    Definition?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    OntologyId?: string | null;

}

export interface IPatchVirtualTreeView
{
    Name?: string | null;
    DisplayName?: string | null;
    Definition?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    OntologyId?: string | null;
    ['@odata.etag']?: string | null;

}

export interface IPutVirtualTreeView
{
    Name?: string;
    DisplayName?: string | null;
    Definition?: string | null;
    Description?: string | null;
    IsEnabled?: YesNoEnum;
    ['@odata.etag']?: string;
    OntologyId?: string;

}
